"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repaymentTapePointerConfig = exports.repaymentFeedPointerMethod = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const tandymCurrencyCode = finley_types_1.Bank.Currency.USD;
const convertOptionalCurrency = common_1.stringConversion.convertOptionalCurrencyFactory(tandymCurrencyCode);
// Default to 0 if amount is not present
const convertCurrency = (amount) => {
    var _a;
    return (_a = convertOptionalCurrency(amount)) !== null && _a !== void 0 ? _a : 0;
};
// Add additional filter to ensure we only process payments with "VALID" status
const isPaymentValid = (status) => {
    return status.trim().toUpperCase() === 'VALID';
};
const repaymentFeedPointerMethod = ({ csvArray, assignedExternalReceivableIds, reportingDate, fileVersion, creditFacilityId, }) => {
    // repayment tape may be associated to master loan tape,
    // as such, we need to filter down repayment tape to just the set of receivables
    // that are in the assigned loan tape
    const idSet = new Set(assignedExternalReceivableIds);
    const filteredCsvArray = lodash_1.default.filter(csvArray, (csvRow) => idSet.has(csvRow.customer_id) && isPaymentValid(csvRow.pymt_status));
    const repaymentEffectiveAmountByDate = lodash_1.default.mapValues(lodash_1.default.groupBy(filteredCsvArray, (csvRow) => csvRow.pymt_valid_date), (csvRows) => lodash_1.default.sumBy(csvRows, (csvRow) => convertCurrency(csvRow.pymt_amt)));
    const dbRows = lodash_1.default.map(lodash_1.default.toPairs(repaymentEffectiveAmountByDate), ([repaymentEffectiveDate, totalRepaymentEffectiveAmount]) => {
        (0, common_1.finleyAssert)(common_1.typeguards.isFullDateStr(repaymentEffectiveDate), new common_1.error.TypeError({
            resourceType: 'repaymentEffectiveDate',
            typeguardName: 'isFullDateStr',
            metadata: {
                logMeta: {
                    repaymentEffectiveDate,
                },
            },
        }));
        return {
            id: (0, uuid_1.v4)(),
            creditFacilityId,
            repaymentEffectiveDate,
            totalRepaymentEffectiveAmount,
            reportingDate,
            fileVersion,
        };
    });
    return lodash_1.default.map(dbRows, (row) => lodash_1.default.mapValues(row, common_1.utils.cleanStrForDb));
};
exports.repaymentFeedPointerMethod = repaymentFeedPointerMethod;
exports.repaymentTapePointerConfig = {
    pointer: 'tandymRivoniaRoadCapital1',
    method: exports.repaymentFeedPointerMethod,
};
//# sourceMappingURL=repaymentFeedPointerMethod.js.map